<template>
  <div class="popup_in">
    <div class="popup pop-filters-mm">
      <button @click="$emit('close')" class="popup_close-bt">
        <img src="/assets/img/svg/close-sm-blue.svg" alt="" />
      </button>
      <h2 class="title-28 mb--22">
        {{ $route.name == "messages" ? "מסנן" : "סינונים" }}
      </h2>
      <div class="pop-filters-mm-tags flex flex--content--center">
        <span
          v-for="(col, i) in columns"
          :key="i"
          class="tb-filter pointer"
          @click="toggleColumn(col.name)"
          :class="{
            active: getIsColumnActive(col.name)
          }"
        >
          {{ col.hebrewName }}
        </span>
      </div>

      <button @click="setFilters" class="bt_blue">החל סינונים</button>
    </div>
  </div>
  <!-- End pop-blocked -->
</template>

<script>
export default {
  data() {
    return {
      columns: [],
      showenTableColumns: []
    };
  },
  mounted() {
    this.columns = [...this.$attrs.columns];
    this.showenTableColumns = [...this.$attrs.showenTableColumns];
  },
  methods: {
    setFilters() {
      this.$attrs.setShownedColumns(this.showenTableColumns);
      this.$emit("close");
    },
    getIsColumnActive(columnName) {
      const found = this.showenTableColumns.find(c => c.name === columnName);
      return found !== undefined;
    },
    toggleColumn(columnName) {
      const index = this.showenTableColumns.findIndex(
        c => c.name === columnName
      );
      if (index === -1) {
        const existsColIndex = this.columns.findIndex(
          c => c.name === columnName
        );
        this.showenTableColumns.splice(
          existsColIndex,
          0,
          this.columns[existsColIndex]
        );
      } else {
        this.showenTableColumns.splice(index, 1);
      }
    }
  }
};
</script>
